import axios from "axios";
import { FETCH_ALL_DEPT_API } from "../Constants/Apis";

export const getDepts = async () => {
  try {
    return axios.get(FETCH_ALL_DEPT_API);
  } catch (e) {
    return console.log(e);
  }
};

export const createDept = async (payload) => {
  try {
    return axios.post(FETCH_ALL_DEPT_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateDept = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_DEPT_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteDept = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_DEPT_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};

